import { initBotId } from "botid/client/core";

// BotID invisible-CAPTCHA protection (Next 15.3+ client instrumentation).
// Lives at the PROJECT ROOT because app/ is at the root (not src/app).
//
// Protects the public search API — the most data-rich anonymous path left
// after the catalog DB-grant lockdown. A direct curl/script can't produce a
// valid token (it never ran this page's JS), so it gets blocked server-side,
// while the header search dropdown (fetched from a real browser session) works.
//
// checkLevel "basic" is FREE and already blocks raw curl/script scrapers. Deep
// Analysis (Kasada) is reserved for low-frequency, high-value routes (checkout)
// — search is high-frequency, so we avoid per-request Kasada cost. The per-route
// checkLevel MUST match the server's checkBotId() call.
initBotId({
  protect: [
    { path: "/api/search/games", method: "GET", advancedOptions: { checkLevel: "basic" } },
    { path: "/api/search/publishers", method: "GET", advancedOptions: { checkLevel: "basic" } },
  ],
});
